import { button } from '../../../../../component/component'

export default function(o,p){

  var type = p.model.getName()

  var remove = function(){

    if(div.getDisabled()){
      return
    }

    var sure =
      confirm('delete '+type+'. are you sure?')
    if(!sure){
      return
    }

    var id = p.item._id

    p.model.remove(o,id,function(error){

      if(error){
        throw error

      } else {

        p.deleted()

      }

    })

  }

  var disabled = !p.item || !p.model.remove

  var div =
    button(null,'fi-trash',disabled)
    .css({
      position: 'absolute',
      right: 0,
    })
    .click(remove)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/edit/form/remove/remove.js